<form [formGroup]="stepFiveForm" class="container-xxl">
  <div class="row justify-content-center">
    <div class="col">
      <div class="fs-5 fw-bold">
        {{"SYSTEM.STEPFIVE.INVERTERCOMPOSE" | translate}}
      </div>
      <button class="btn btn btn-outline-primary mr-2" 
        (click)="addInverter({id: 0, serialnumber: '', model: ''})">
        {{"SYSTEM.STEPFIVE.ADDINVERTER" | translate}}
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="container">
        <div class="row mt-4">
          <div class="col-12 col-md-6 col-lg-4 mb-2"
            *ngFor="let inverterItem of inverterFieldAsFormArray.controls; let i = index"
            formArrayName="inverters_list">
            <mat-card class="mb-1">
              <div [formGroupName]="i">
                <mat-card-header style="border-bottom: 2px solid lightgray;" class="bg-primary bg-opacity-10">
                  <mat-card-title style="font-weight: bold; font-size: medium;">
                    {{ "SYSTEM.STEPFIVE.INVERTER" | translate}} {{i+1}}
                  </mat-card-title>
                  <!-- Aggiungi il pulsante "X" per rimuovere -->
                  <button type="button" class="close" (click)="removeInverter(i)">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-card-header>
                <mat-card-content class="pb-2 pl-0 pr-0">
                  <div class="container-fluid pb-3">
                    <div class="row">
                      <div class="col-12">
                        <label class="mt-2" style="font-weight: bold; font-size: small;">
                          {{ "SYSTEM.STEPFIVE.SERIALNUMBER" | translate}}<sup>*</sup>
                        </label>
                      </div>
                      <div class="col-12" style="position: relative;">
                        <input class="form-control" type="text" formControlName="serialnumber"
                          [class.is-invalid]="inverterItem.get('serialnumber')?.invalid && (inverterItem.get('serialnumber')?.dirty || submitted)">
                        <!-- <app-scanner-selector class="cameraIcon" (barcodeScanned)="onBarcodeScanned($event, i)">
                        </app-scanner-selector> -->
                        <app-scanner-barcode-button class="cameraIcon" (barcodeScanned)="onBarcodeScanned($event, i)"></app-scanner-barcode-button>
                      </div>
                      <div class="col-12">
                        <label class="mt-2" style="font-weight: bold; font-size: small;">
                          {{"SYSTEM.STEPFIVE.MODEL" | translate}}<sup>*</sup>
                        </label>
                        <input class="form-control" type="text" formControlName="model"
                          [class.is-invalid]="inverterItem.get('model')?.invalid && (inverterItem.get('model')?.dirty || submitted)">
                        <div class="text-danger mt-1"
                          *ngIf="inverterItem.get('model')?.invalid && (inverterItem.get('model')?.dirty || submitted)"
                          style="font-size: small;">{{"SYSTEM.STEPFIVE.MODELERROR" | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="inverterFieldAsFormArray.length > 1">
    <div class="col-12 mt-1 mb-2 ms-3 form-check form-switch">
      <input class="form-check-input" type="checkbox" role="switch" id="inverter_communication"
        formControlName="inverter_communication">
      <label class="form-check-label" for="inverter_communication">
        {{ "SYSTEM.STEPFIVE.PARALLELCOMUNICATION" | translate}}
      </label>
    </div>
    <div class="col-12 mt-3 ms-3 form-check form-switch">
      <input class="form-check-input" type="checkbox" role="switch" id="inverter_power"
        formControlName="inverter_power">
      <label class="form-check-label" for="inverter_power">
        {{ "SYSTEM.STEPFIVE.PARALLELPOWER" | translate}}
      </label>
    </div>
  </div>
  <div *ngIf="!isReadonly && listerrorsn.length > 0" class="row justify-content-center mt-2">
    <div class="col-12 text-center mt-1 mb-1">
      <span *ngIf="listerrorsn.length == 1">
        {{"SYSTEM.STEPFIVE.ERRORSNSINGULAR" | translate}}:
      </span>
      <span *ngIf="listerrorsn.length > 1">
        {{"SYSTEM.STEPFIVE.ERRORSNPLURAL" | translate}}: 
      </span>
      <span *ngFor="let item of listerrorsn; let i = index" style="color: rgb(195, 0, 0);">
        "{{item}}" {{i == listerrorsn.length - 1 ? '.' : ','}}
      </span><br>
      <span >
        {{"SYSTEM.STEPFIVE.PRESSBUTTON" | translate}}
      </span>
    </div>
    <div class="col-12 text-center mb-4 px-0">
      <button class="btn btn-outline-danger" (click)="confirmEmailPopUp()">
        {{"SYSTEM.STEPFIVE.SENDEMAIL" | translate}}
      </button>
    </div>
  </div>
  <div *ngIf="!isReadonly; else updateBlock" class="row justify-content-center">
    <div class="col-12 text-center px-0">
      <button class="btn btn-outline-dark me-0 me-md-2" (click)="previous()">
        {{"SYSTEM.STEPBUTTONS.PREV" | translate}}
      </button>
      <button class="btn btn-outline-dark ms-1 me-1 ms-md-2 me-md-2" id="next" (click)="saveStep('save')">
        {{"SYSTEM.STEPBUTTONS.SAVE" | translate}}
      </button>
      <button class="btn btn-outline-dark me-0 ms-md-2"
        [disabled]="stepFiveForm.invalid || inverterFieldAsFormArray.length == 0" (click)="saveStep('next')">
        {{"SYSTEM.STEPBUTTONS.NEXT" | translate}}
      </button>
    </div>
  </div>
  <ng-template #updateBlock>
    <div class="col-12 text-center">
      <button class="btn btn-outline-dark" (click)="approvalRequested()">
        {{"SYSTEM.STEPBUTTONS.UPDATE" | translate}}
      </button>
    </div>
  </ng-template>

</form>
